import { VFC } from 'react'
import { withUser } from 'src/api/user'
import { asModal } from 'src/components/hoc/asModal'
import { MESSAGE_HEADER_HEIGHT } from 'src/compositions/Messages/Message/Header'
import { EMPTY_USER } from 'src/models/User'
import { black, trueblack, white } from 'src/styles/colors'
import styled, { css } from 'styled-components'
import { Button } from '../UserCard'
import { PrDetailCardProps } from '../UserCard/PrDetailCard'
import { CompanySection } from './CompanySection'
import { ConnectionCompaniesSection } from './ConnectionCompaniesSection'
import { IsIntroductoryTextsSection } from './IntroductoryTextsSection'
import { PersonaSection } from './PersonaSection'
import { ProfileHeader } from './ProfileHeader'
import { ResponsibilitiesSection } from './ResponsibilitiesSection'
import { ProfilePreviewProps } from './types'

const ProfilePreviewContent: VFC<ProfilePreviewProps> = (props) => {
  const { user, close } = props
  if (user === EMPTY_USER) {
    close()
    return <></>
  }
  return (
    <Layout>
      <ProfileHeader {...props} />
      <Body>
        <ConnectionCompaniesSection {...props} />
        <IsIntroductoryTextsSection {...props} />
        <PersonaSection {...props} />
        <CompanySection {...props} />
        <ResponsibilitiesSection {...props} />
      </Body>
    </Layout>
  )
}

export const ProfilePreviewWithButtonContent: VFC<ProfilePreviewProps> = ({
  user,
  close,
  actions,
  onClickKeep,
  displayCertified,
  mutate,
}) => (
  <>
    <ProfilePreviewContent
      user={user}
      close={close}
      onClickKeep={onClickKeep}
      displayCertified={displayCertified}
      mutate={mutate}
    />
    {!user.company.messageAvailable && (
      <Buttons>
        {actions &&
          actions.map(({ label, onClick, styles, hidden, disabled }) => (
            <Button
              key={label}
              onClick={() => onClick(user)}
              styles={styles}
              hidden={typeof hidden === 'function' ? hidden(user) : hidden}
              disabled={
                typeof disabled === 'function' ? disabled(user) : disabled
              }
              numOfSiblings={actions.length}
            >
              {label}
            </Button>
          ))}
      </Buttons>
    )}
  </>
)

const modalOverlayStyle = css`
  backdrop-filter: blur(6px) brightness(0.5);
  background-color: white;
`
export const ProfilePreviewModal = asModal(ProfilePreviewContent, {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})
const ProfileEditPreviewModalStyle = css`
  ${modalOverlayStyle}
  margin-top: calc(${MESSAGE_HEADER_HEIGHT} - 2px);
`
export const ProfileEditPreviewModal = asModal(ProfilePreviewContent, {
  overlayStyle: ProfileEditPreviewModalStyle,
  scrollable: true,
})

export const ProfilePreviewWithButtonModal = asModal(
  ProfilePreviewWithButtonContent,
  {
    overlayStyle: modalOverlayStyle,
    scrollable: true,
  },
)

export const ProfileViewModal = asModal<{
  id: number
}>(withUser(ProfilePreviewContent), {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})

export const ProfileWithButtonModal = asModal<{
  id: number
  close: () => void
  actions?: PrDetailCardProps['actions']
  onClickKeep?: (id: number, isDelete: boolean) => void
}>(withUser(ProfilePreviewWithButtonContent), {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})

const Layout = styled.div`
  width: 100%;
  max-width: min(100vw, 736px);
  max-height: 80vh;
  overflow: auto;
  border-radius: 5px;
  box-shadow: 0 5px 15px ${trueblack}80;
`

const Body = styled.div`
  background-color: ${white};
  padding: 20px 16px;
`

const Buttons = styled.div`
  display: flex;
  max-width: min(100vw, 736px);
  margin-top: 20px;
  justify-content: center;
  flex-wrap: wrap;
  background-color: ${black};
  border-radius: 5px;

  button {
    margin: 24px 0;
    box-shadow: none;
  }
`
